"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CheckBox = function (props) {
    return (react_1.default.createElement("label", { className: "formsCommon-CheckBox" },
        react_1.default.createElement("input", { type: "checkbox", checked: props.checked, onChange: function () { return props.onChange(!props.checked); } }),
        react_1.default.createElement("span", { className: "formsCommon-CheckBox_Label" }, props.label)));
};
exports.default = CheckBox;
